import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import BookingSyncLogViewForm from './BookingSyncLogViewForm'
import BookingSyncLogAddForm from './BookingSyncLogAddForm'
import BookingSyncLogEditForm from './BookingSyncLogEditForm'
import Namespace from 'src/constants/locale/Namespace'
import BookingSyncLogKeys from 'src/constants/locale/key/BookingSyncLog'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [bookingSyncLogId, setBookingSyncLogId] = useState('')
  const { translate } = useTranslation([
    Namespace.BOOKING_SYNC_LOG,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let bookingSyncLog = translate(
      Namespace.BOOKING_SYNC_LOG,
      BookingSyncLogKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: bookingSyncLog
      }
    )

    return {
      bookingSyncLog,
      tabLockedMessage
    }
  }

  function makeTransactionLogForm() {
    if (bookingSyncLogId === '') {
      return (
        <BookingSyncLogAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setBookingSyncLogId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <BookingSyncLogEditForm
          showNotification={showNotification}
          id={bookingSyncLogId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <BookingSyncLogViewForm
              showNotification={showNotification}
              id={bookingSyncLogId}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.transactionLog,
              tabContent: makeTransactionLogForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage